import React from 'react';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';

import { configurationStore } from '@app/Stores/ConfigurationStore';
import { Icon } from './Icon';
import { PrincipalConfig } from '@app/AppConstants';
import { emitter } from '@app/Services/EventEmitter';
import DevExtremeCssService from '@app/Services/DevExtremeCssService';

@observer
export default class ThemeSwitcher extends React.Component<{ title?: string; }> {
    @observable public enableDarkMode: boolean = false;
    
    async componentDidMount() {
        const darkModeQuery = configurationStore.get(PrincipalConfig.viewGroup, PrincipalConfig.darkMode);
        const darkMode = await darkModeQuery;
        
        this.switchDarkMode(!!darkMode && !!JSON.parse(darkMode), false);
    }

    render() {
        return (
            <div title="Switch Dark \ Light theme" className={'main-nav-theme' + (this.enableDarkMode ? ' dark' : '')} onClick={() => this.switchDarkMode(!this.enableDarkMode, true)}>
                {this.enableDarkMode ? <Icon name="moon" noSolid /> : <Icon name="sun" noSolid />}
                {this.props.title && <div className={'title'}>{this.props.title}</div>}
            </div>
        );
    }
    
    @action
    public switchDarkMode (value: boolean, saveToConfig: boolean) {
        this.enableDarkMode = value;
        const root = document.getElementsByTagName('html')[0];
        if (value){
            root.classList.add('dark');
            localStorage.setItem('dark', 'true');
        } else {
            root.classList.remove('dark');
            localStorage.removeItem('dark');
        }

        const link = document.getElementById(DevExtremeCssService.LinkId) as HTMLLinkElement;
        if (link){
            link.href = root.classList.contains('dark') ? '/css/devextreme_dark.css' : '/css/devextreme.css';
        }

        emitter.emit('theme', value ? 'dark' : '');
        
        saveToConfig && configurationStore.set(PrincipalConfig.viewGroup, PrincipalConfig.darkMode, JSON.stringify(this.enableDarkMode));
    }
}